import { Button } from "@mui/material";
import React from "react";
import useConfirm from "../../../hooks/useConfirm";
import { CHANGE_EMAIL } from "../../../enums/ApiPaths";
import { getBearerToken, getUserEmail } from "../../../utils/Functions";
import authApi from "../../../utils/api/authApi";
import { HttpStatusCode } from "axios";
import { ERROR, SUCCESS } from "../../../enums/AlertTypes";
import { useTranslation } from "react-i18next";
import { SnackbarContext } from "../../../contexts/Snackbar";
import useUser from "../../../hooks/useUser";

export default function EmailEdit() {
  const { t } = useTranslation();
  const {profile} = useUser();
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("Attention"),
    t("Accept"),
    t("Cancel")
  );
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const handleChangeEmail = async () => {
    getMessage(t("ConfirmWantedEmailChange"));
    const ans = await confirm();

    if (ans) {
      try {
        const header = await getBearerToken();
        const data = {
          email: profile.email
        };
        let res = await authApi.post(CHANGE_EMAIL, data, {
          headers: header,
        });

        if (res.status == HttpStatusCode.Ok) {
          handleSnackbar("EmailConfirmationSentSuccesfully", SUCCESS);
        }
      } catch (e) {
        handleSnackbar(e?.response?.data, ERROR);
      }
    }
  };
  return (
    <React.Fragment>
      <Button variant="outlined" onClick={() => handleChangeEmail()}>
        {t("Change")}
      </Button>
      <ConfirmationDialog />
    </React.Fragment>
  );
}
